import { Component, Input } from '@angular/core';

import { trackById } from '../../../shared/util/track-by.util';
import { ICustomFieldValue } from '../../interfaces/custom-field.interface';

@Component({
  selector: 'lum-custom-field-display-columns',
  templateUrl: './custom-field-display-columns.component.html',
  styleUrls: ['./custom-field-display-columns.component.scss'],
})
export class CustomFieldDisplayColumnsComponent {
  @Input()
  customFieldValues :ICustomFieldValue[] = [];

  trackById = trackById;
}
